export default "__VITE_ASSET__C3zbfx6V__"